export const forEachElement = (selector, callback) => {
  document.querySelectorAll(selector).forEach((element) => callback(element));
};
